import { useQueryClient } from '@tanstack/react-query'

import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateGameTypeProvider from '@/modules/game/api/hooks/useMutationUpdateGameTypeProvider'
import { GameQueryKeys } from '@/modules/game/keys'

import type { GameProviderWithBannerListTableData } from '@/modules/game/type'

interface IsNewProviderProps {
	row: GameProviderWithBannerListTableData
}

export function IsNewProvider({ row }: IsNewProviderProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateGameTypeProvider } =
		useMutationUpdateGameTypeProvider()

	const handleMutate = async (value: boolean) => {
		await updateGameTypeProvider({
			id: row.id,
			payload: {
				isNew: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [GameQueryKeys.GetGameProviderList],
		})
	}

	return (
		<SetIsActive
			defaultChecked={row.isNew}
			onMutate={handleMutate}
			successMessage="อัพเดทค่ายใหม่สำเร็จ"
		/>
	)
}
